<template>
  <view-wrapper
    prefix="Edit"
    name="Integrationclient"
    path="integrationclients"
    :showCancel="true"
    :saveFunc="editIntegrationClient"
    :hasChangesBeenMade="hasChangesBeenMade"
    :loading="loading"
    :validation="validation"
  >
    <wrapper class="mb-5" :checkForChildFocused="true">
      <grafokett-input
        type="text"
        labelPlaceholder="Name"
        v-model="formData.name"
        :editable="true"
      />
      <grafokett-input
        type="text"
        labelPlaceholder="Description"
        v-model="formData.description"
        :editable="true"
      />
      <span class="text-xs text-white" v-if="selectedGroups.length > 0"
        >Default Groups</span
      >
      <multiselect
        v-model="selectedGroups"
        :options="groups"
        :multiple="true"
        :close-on-select="true"
        placeholder="Default Groups"
        label="name"
        track-by="id"
      />
    </wrapper>
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../../components/forms/Input.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    GrafokettInput,
    Multiselect,
  },
  data() {
    return {
      loading: false,
      formData: {},
      defaultData: {},
      selectedGroups: [],
      groups: [],
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      const { data: groupsData } = await this.$store.$api.get("/api/groups");

      if (groupsData)
        this.groups = groupsData.data.map(({ id, name }) => ({
          id,
          name,
        }));

      const { integrationClientId } = this.$route.params;

      const response = await this.$store.$api.get(
        `/api/integrationclient/${integrationClientId}`
      );

      const {
        id,
        name,
        description,
        integrationClientGroups,
      } = response.data.data;

      this.formData = { id, name, description };
      this.defaultData = { id, name, description };

      if (integrationClientGroups && integrationClientGroups.length > 0) {
        const groupIds = integrationClientGroups.map(g => g.groupId);

        if (groupIds && groupIds.length) {
          this.selectedGroups = this.groups.filter(x =>
            groupIds.includes(x.id)
          );
        }
      }

      this.loading = false;
    },
    async editIntegrationClient() {
      this.loading = true;
      await this.$store.$api.put("/api/integrationclient", {
        ...this.formData,
        groupIds:
          this.selectedGroups && this.selectedGroups.length > 0
            ? this.selectedGroups.map(g => g.id)
            : [],
      });
      this.loading = false;
    },
    hasChangesBeenMade() {
      if (
        this.formData.name !== this.defaultData.name ||
        this.formData.description !== this.defaultData.description
      )
        return true;

      return false;
    },
    validation() {
      const { name } = this.formData;

      const value =
        name &&
        name.length &&
        name.length > 0 &&
        name.length <= 128 &&
        name !== "" &&
        name !== " ";

      return value || false;
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>

<style></style>
